(function () {
  function init() {
    const existing = document.getElementById("zoom");
    if (existing) existing.remove();

    let modal = null;
    let images = [];
    let index = 0;
    let touchStartX = null;

    function ensureModal() {
      if (modal) return modal;
      modal = document.createElement("div");
      modal.id = "zoom";
      const chevron =
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M15 6 9 12l6 6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
        "</svg>";
      modal.innerHTML = [
        '<img alt="" />',
        '<span class="zoom__exit" role="button" aria-label="Schließen">&times;</span>',
        '<button type="button" class="zoom__nav zoom__prev" aria-label="Vorheriges Bild">' + chevron + "</button>",
        '<button type="button" class="zoom__nav zoom__next" aria-label="Nächstes Bild">' + chevron + "</button>",
        '<div class="zoom__overlay"></div>',
      ].join("");
      document.body.append(modal);

      modal.querySelector(".zoom__exit").addEventListener("click", close);
      modal.querySelector(".zoom__overlay").addEventListener("click", close);
      modal.addEventListener("click", function (e) {
        if (e.target === modal) close();
      });
      modal.querySelector(".zoom__prev").addEventListener("click", function (e) {
        e.stopPropagation();
        navigate(-1);
      });
      modal.querySelector(".zoom__next").addEventListener("click", function (e) {
        e.stopPropagation();
        navigate(1);
      });
      return modal;
    }

    function loadImage(src) {
      const img = modal.querySelector("img");
      modal.classList.remove("loaded");
      img.src = src;
      if (img.complete && img.naturalWidth > 0) {
        modal.classList.add("loaded");
      } else {
        img.addEventListener("load", function onLoad() {
          modal.classList.add("loaded");
          img.removeEventListener("load", onLoad);
        });
      }
    }

    function updateNav() {
      const prev = modal.querySelector(".zoom__prev");
      const next = modal.querySelector(".zoom__next");
      const prevDisabled = index <= 0;
      const nextDisabled = index >= images.length - 1;

      prev.disabled = prevDisabled;
      next.disabled = nextDisabled;
      prev.setAttribute("aria-disabled", prevDisabled ? "true" : "false");
      next.setAttribute("aria-disabled", nextDisabled ? "true" : "false");
      prev.style.display = "";
      next.style.display = "";
    }

    function open(imgs, startIndex) {
      ensureModal();
      images = imgs;
      index = startIndex;

      modal.classList.add("opened");
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";

      loadImage(images[index]);
      updateNav();

      document.addEventListener("keydown", onKey);
      modal.addEventListener("touchstart", onTouchStart, { passive: true });
      modal.addEventListener("touchend", onTouchEnd, { passive: true });
    }

    function close() {
      if (!modal) return;
      modal.classList.remove("opened");
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
      document.removeEventListener("keydown", onKey);
      modal.removeEventListener("touchstart", onTouchStart);
      modal.removeEventListener("touchend", onTouchEnd);

      setTimeout(function () {
        modal.classList.remove("loaded");
        const img = modal.querySelector("img");
        if (img) {
          img.removeAttribute("src");
          img.style.cssText = "";
        }
      }, 300);
    }

    function navigate(direction) {
      const newIndex = index + direction;
      if (newIndex < 0 || newIndex >= images.length) return;
      index = newIndex;
      loadImage(images[index]);
      updateNav();
    }

    function onKey(e) {
      if (e.key === "ArrowLeft") navigate(-1);
      else if (e.key === "ArrowRight") navigate(1);
      else if (e.key === "Escape") close();
    }

    function onTouchStart(e) {
      touchStartX = e.touches[0].clientX;
    }

    function onTouchEnd(e) {
      if (touchStartX === null) return;
      const delta = e.changedTouches[0].clientX - touchStartX;
      touchStartX = null;
      if (Math.abs(delta) > 50) navigate(delta < 0 ? 1 : -1);
    }

    document.addEventListener(
      "click",
      function (e) {
        const trigger = e.target.closest && e.target.closest("product-image-zoom");
        if (!trigger) return;

        e.stopImmediatePropagation();
        e.preventDefault();

        const gallery = trigger.closest(".product-gallery-main") || document;
        const allZooms = Array.prototype.slice.call(
          gallery.querySelectorAll("product-image-zoom")
        );
        const imgs = allZooms
          .map(function (el) {
            return el.getAttribute("data-image");
          })
          .filter(Boolean);
        const idx = Math.max(0, allZooms.indexOf(trigger));

        open(
          imgs.length ? imgs : [trigger.getAttribute("data-image")],
          idx
        );
      },
      true
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
